import type { IconSvgObject } from './types';

const SparklesIcon: IconSvgObject = [
  ["path", { d: "M15 2C15.944 6.19089 17.579 8.00412 22 9C17.8091 9.94405 15.9959 11.579 15 16C14.056 11.8091 12.421 9.99588 8 9C12.421 8.00412 14.056 6.19089 15 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 12C7.71134 15.1579 9.00651 16.3257 12 17C8.84214 17.7113 7.67432 19.0065 7 22C6.28866 18.8421 4.99349 17.6743 2 17C5.15786 16.2887 6.32568 14.9935 7 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SparklesIcon;
